module.exports = __webpack_public_path__ + "media/images/emblems/Matten_bei_Interlaken-coat_of_arms-2fbd59720049062d30b5c9ae80663adf.svg";